import { cn } from '@/lib/utils';

export interface ThumbDownProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export function ThumbDown({
  size = 16,
  width,
  height,
  fill = '#969AAC',
  className,
  ...props
}: ThumbDownProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 14.6667 13.3333"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M9.33333 0H3.33333C2.78 0 2.30667 0.333333 2.10667 0.813333L0.0933333 5.51333C0.0333333 5.66667 0 5.82667 0 6V7.33333C0 8.06667 0.6 8.66667 1.33333 8.66667H5.54L4.90667 11.7133L4.88667 11.9267C4.88667 12.2 5 12.4533 5.18 12.6333L5.88667 13.3333L10.28 8.94C10.52 8.7 10.6667 8.36667 10.6667 8V1.33333C10.6667 0.6 10.0667 0 9.33333 0ZM9.33333 8L6.44 10.8933L7.33333 7.33333H1.33333V6L3.33333 1.33333H9.33333V8ZM12 0H14.6667V8H12V0Z"
        fill={fill}
      />
    </svg>
  );
}
